<script>
import { mapState } from 'vuex';

export default {
    name: 'AmplitudeHandler',
    computed: {
        ...mapState('Auth', ['user']),
    },
    watch: {
        user: {
            handler(newUser) {
                if (newUser && this.$amplitude) {
                    this.$amplitude.setUserId(newUser.id);
                }
            },
            immediate: true,
        },
    },
    render() {
        return null;
    },
};
</script>
